import { addMonths } from "date-fns";
import { CalendarCircuitCriteria } from "../objects/calendarCriteria";

export const EMPTY_CALENDAR_CRITERIA: CalendarCircuitCriteria = {
    start_date: new Date(),
    end_date: addMonths(new Date(), 1),
    filters: {
        contracts: [],
        destinations: [],
        categories: [],
        countries: [],
        type: [],
        package_type: [],
    }
};
